import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";
import ItemSlotView from "./ItemSlotView";
import GameElementSkinFactory from "./GameElementSkinFactory";
import SlotEvent from "./SlotEvent";
import { isNull } from "../../../../../shared/lib/html5-software-library/src/ranj/util/TypeUtil";

export default class BaseItemCollectionView extends AbstractView {

    /**
     * @param {createjs.DisplayObject} target 
     * @param {GameElementSkinFactory} elementFactory 
     */
    constructor(target, elementFactory) {
        super(target);

        this._elementFactory = elementFactory;

        this._slots = [];
        for (let i = 0; i < 999; i++) {
            const mc = target[`slot${i}`];
            if (!mc) {
                break;
            }
            const slot = new ItemSlotView(mc);
            slot.index = i;
            this._slots.push(slot);
            slot.addEventListener(ItemSlotView.CLICK, this._handleSlotClick.bind(this));
        }

        /**@type {ItemSlotView} */
        this._selectedSlot = null;
    }
    
    clear() {
        this._slots.forEach(slot => slot.clear(null));
    }

    fill(itemIds) {
        itemIds.forEach((itemId, index) => {
            this.fillSlot(index, itemId);
        });
    }

    fillSlot(index, itemId) {
        const item = !isNull(itemId) ? this.getItem(itemId) : null;
        this._slots[index].fill(item);
    }

    getItem(id) {
        const item = this._elementFactory.getItem(id);
        item.itemId = id;
        return item;
    }

    set enabled(bool) {
        this._enabled = bool;
        this._slots.forEach(slot => slot.enabled = bool);
    }

    get enabled() {
        return this._enabled;
    }

    _handleSlotClick(e) {
        const slot = e.target;
        this.selectSlot(slot);
    }
    
    unselect() {
        this.selectSlot(null);
    }

    selectSlot(slot) {
        if (this._selectedSlot) {
            this._selectedSlot.selected = false;
        }
        if (slot) {
            slot.selected = true;
        }
        this._selectedSlot = slot;
        this.dispatchEvent(SlotEvent.SELECTED, this._selectedSlot);
    }

    get selectedSlot() {
        return this._selectedSlot;
    }
}
